// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"SQ-z","inlineTitle":"TQ-z","sponsoredAdsWrapper":"UQ-z","marketplaceRecosWrapper":"VQ-z"};